// @ts-check
// @ts-ignore
require('../css/login.less');
const $ = require('jquery');
const md5 = require('md5');
const { encrypt_remote_text } = require('../../lib/util');

/**
 * Language
 */
const Language = (() => {
  const lan_string = [
    'en_US',
    'zh_TW',
    'ja_JP',
    'ru_RU',
    'fr_FR',
    'de_DE',
    'tr_TR',
    'ar_SA',
    'pl_PL'
  ];
  const transltations = {
    Login: [
      '登入',
      'ログイン',
      'Войти ',
      "S'identifier",
      'Anmelden',
      'Login',
      'تسجيل دخول',
      'Logowanie'
    ],
    Account: ['帳戶', 'アカウント', 'Аккаунт', 'Compte', 'Konto', 'Hesap', 'الحساب', 'Konto'],
    Password: [
      '密碼',
      'パスワード',
      'Пароль',
      'Mot de passe',
      'Passwort',
      'Şifre',
      'الرقم السرى',
      'Hasło'
    ],
    Username: [
      '使用者帳號',
      'ユーザー名',
      'Имя пользователя ',
      "Nom d'utilisateur",
      'Benutzername',
      'Kullanıcı ismi',
      'إسم المستخدم ',
      'Nazwa użytkownika'
    ],
    Confirm: [
      '確認',
      '確認',
      'Подтвердить ',
      'Confirmer',
      'Bestätigen',
      'Onayla',
      'تأكيد',
      'Potwierdź'
    ],
    Cancel: ['取消', 'キャンセル', 'Отменить', 'Annuler', 'Abbrechen', 'İptal', 'إلغاء', 'Anuluj'],
    'Account/Password Error!': [
      '帳戶名稱或密碼錯誤!',
      'アカウント/パスワード エラー!',
      'Логин или пароль указан неверно!',
      'Compte/ Mot de passe errone!',
      'Konto-/Passwortfehler!',
      'Hesap/Şifre Hatası!',
      'خطأ في أدخال الحساب / كلمة السر ',
      'Błąd konta/hasła!'
    ],
    'User Information': [
      '使用者帳號資訊',
      'ユーザー情報',
      'Информация о пользователе',
      'Information Utilisateur',
      'Benutzerinformation',
      'Kullanıcı bilgisi',
      'معلومات المستخدم ',
      'Informacje o użytkowniku'
    ],
    Setup: [
      '設置',
      '設定',
      'Настройка',
      'Parametrage',
      'Einstellungen',
      'Ayar',
      'الضبط',
      'Konfiguracja'
    ],
    OK: ['OK', 'OK', 'Ok', 'OK', 'OK', 'Ok', 'OK', 'OK'],
    'New Password': [
      '新增密碼',
      '新パスワード',
      'Новый пароль',
      'Nouveau mot de passe',
      'Neues Passwort',
      'Yeni Şifre',
      'الرقم السرى الجديد',
      'Nowe hasło'
    ],
    'Confirm Password': [
      '確認密碼',
      'パスワード確認',
      'Подтвердить пароль',
      'Confirmer mot de passe',
      'Passwort bestätigen',
      'Sifreyi Onayla',
      'تأكيد كلمة المرور',
      'Potwierdź hasło'
    ],
    "These passwords don't match. Please try again.": [
      '密碼不符合\n請重新輸入',
      'パスワードが違います。もう一度試してください。',
      'Пароли не совпадают. Пожалуйста,\n попробуйте еще раз.',
      'Ces mots de passe ne correspondent pas. Veuillez essayer encore',
      'Diese Passwörter stimmen nicht überein. Bitte versuchen Sie es erneut.',
      'Bu şifreler uyuşmuyor. Tekrar deneyiniz.',
      'الرقم السرى غير صحيح,الرجاء محاولة مرة إخرى',
      'Hasła nie pasują do siebie. Spróbuj ponownie.'
    ],
    "Password length is 8-16 characters(Available characters: A-Z, a-z, 0-9, !#$%&'-.@^_~)": [
      "密碼長度為8-16字元(可用字元:A-Z, a-z, 0-9, !#$%&'-.@^_~)",
      "パスワードの長さは8〜16文字です（使用可能な文字：A〜Z、a〜z、0〜9、 !#$%&'-.@^_~）",
      '',
      '',
      "Passwortlänge ist 8-16 Zeichen (erlaubte Zeichen: A-Z, a-z, 0-9, !#$%&'-.@^_~)",
      '',
      '',
      "Długość hasła wynosi 8-16 znaków (dostępne znaki: A-Z, a-z, 0-9, !#$%&'-.@^_~)"
    ],
    'Setup account/password failed!': [
      '設定帳號/密碼錯誤!',
      'アカウント/パスワード設定失敗！',
      '',
      '',
      'Einrichten von Konto/Passwort fehlgeschlagen!',
      'Hesap / Şifre kurulumu başarısız!',
      'ضبط الحساب / خطأ في كلمة السر ',
      'Konfiguracja konta/hasła nie powiodła się!'
    ],
    'Password Setting': [
      '密碼設置',
      'パスワード設定',
      '',
      '',
      'Passwort-Einstellung',
      '',
      '',
      'Ustawienie hasła'
    ]
  };

  const lanIdx = getLanguage();

  function getLanguage() {
    let lanStr = localStorage.getItem('language');
    if (lanStr === null) {
      // @ts-ignore
      lanStr = (navigator.language || navigator.userLanguage).split('-').join('_');
    }
    let lan = lan_string.indexOf(lanStr);
    if (lan < 0) {
      lan = 0;
    }
    return lan;
  }

  return {
    trans(text) {
      const transArray = transltations[text];
      if (!transArray) {
        console.error(`translation of '${text}' not defined`);
        return text;
      }
      if (lanIdx === 0) {
        return text;
      }
      return transArray[lanIdx - 1] || text;
    }
  };
})();

/**
 * API
 */
const Api = (() => {
  let _username = '';
  let _password = '';
  let _csrfToken = '';

  return {
    keepAlive() {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'GET',
          url: '/keep_alive',
          dataType: 'json',
          cache: false,
          headers: {
            'X-CSRF-TOKEN': this.csrfToken
          },
          success: (data, textStatus, jqXHR) => {
            resolve();
          },
          error: (jqXHR, textStatus, errorStr) => {
            reject();
          }
        });
      });
    },
    login(username, password) {
      return new Promise((resolve, reject) => {
        const account = this.encodedAccount(username, password);

        $.ajax({
          type: 'POST',
          url: '/login',
          data: `account=${account}`,
          dataType: 'json',
          success: (data, textStatus, jqXHR) => {
            if (data.code) {
              reject(data.msg);
              return;
            }
            if (data.output.csrf_token) {
              _csrfToken = data.output.csrf_token;
              _username = username;
              _password = password;
            }
            resolve(data);
          },
          error: (jqXHR, textStatus, errorStr) => {
            reject('Network error!');
          }
        });
      });
    },
    editPassword(newPassword) {
      if (newPassword === this.password) {
        return Promise.resolve();
      }
      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'POST',
          url: '/setup/account_edit',
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          data: JSON.stringify({
            account: this.username,
            new_account: this.username,
            password: encrypt_remote_text(this.password),
            new_password: encrypt_remote_text(newPassword)
          }),
          headers: {
            'X-CSRF-TOKEN': this.csrfToken
          },
          success: (data, textStatus, jqXHR) => {
            if (data.code) {
              reject(data.msg);
            } else {
              setTimeout(resolve, 1000);
            }
          },
          error: (jqXHR, textStatus, errorStr) => {
            reject();
          }
        });
      });
    },
    encodedAccount(username, password) {
      return md5(username + ':' + password);
    },
    get username() {
      return _username;
    },
    get password() {
      return _password;
    },
    get csrfToken() {
      return _csrfToken;
    }
  };
})();

/**
 * DialogForm
 */
const DialogForm = (function () {
  function _initTemplate(spec, mode) {
    // Create Template
    const form = document.createElement('form');
    form.className = `dialog ${mode}`;

    const title = document.createElement('div');
    title.className = 'title';
    title.textContent = spec.titleText;

    const body = document.createElement('div');
    body.className = 'body';

    const inputElements = [];
    spec.inputs.forEach(
      ({
        labelText,
        type,
        id,
        value = '',
        required = false,
        disabled = false,
        autocomplete = 'on'
      }) => {
        const group = document.createElement('div');
        group.className = 'input-group';

        const label = document.createElement('label');
        label.textContent = labelText + ':';
        label.htmlFor = id;

        const input = document.createElement('input');
        input.type = type;
        input.id = id;
        input.value = value;
        input.required = required;
        input.disabled = disabled;
        input.autocomplete = autocomplete;

        group.appendChild(label);
        group.appendChild(input);
        body.appendChild(group);
        inputElements.push(input);
      }
    );

    const errorMsg = document.createElement('div');
    errorMsg.className = 'input-group error';
    errorMsg.textContent = spec.errorText;
    body.appendChild(errorMsg);

    const buttonRow = document.createElement('div');
    buttonRow.className = 'button-row';
    const confirmBtn = document.createElement('button');
    confirmBtn.type = 'submit';
    confirmBtn.textContent = spec.submitBtnText;
    const cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.textContent = spec.cancelBtnText;

    buttonRow.appendChild(confirmBtn);
    buttonRow.appendChild(cancelBtn);
    body.appendChild(buttonRow);

    // Insert Template
    form.appendChild(title);
    form.appendChild(body);
    spec.container.appendChild(form);

    return { form, errorMsg, confirmBtn, cancelBtn, inputElements };
  }
  const MODES = new Set(['idle', 'error', 'busy', 'hide']);

  return {
    init(spec) {
      let _mode = 'hide';
      const { form, inputElements, cancelBtn, errorMsg } = _initTemplate(spec, _mode);
      const firstEnableInputIdx = spec.inputs.findIndex(input => !input.disabled);
      const firstEnableInput = inputElements[firstEnableInputIdx];

      form.addEventListener('submit', e => {
        e.preventDefault();
        if (document.activeElement.tagName === 'INPUT') {
          // @ts-ignore
          document.activeElement.blur();
        }
        spec.onSubmit.call(this, form);
      });

      form.addEventListener('input', e => {
        if (_mode !== 'idle') {
          this.setMode('idle');
        }
      });

      cancelBtn.addEventListener('click', () => {
        inputElements.forEach((inputElm, idx) => {
          inputElm.value = spec.inputs[idx].value || '';
        });
        this.setMode('idle');
      });

      // global variables
      Object.defineProperty(this, 'form', {
        get() {
          return form;
        }
      });
      Object.defineProperty(this, 'mode', {
        get() {
          return _mode;
        }
      });
      // priviged method
      this.setMode = mode => {
        // Check mode is valid
        if (!MODES.has(mode)) {
          throw new Error(`Invalid mode = ${mode}`);
        }

        // Change class accroding to mode
        this.form.classList.remove(_mode);
        this.form.classList.add(mode);

        // Autofocus input
        if (mode === 'idle' && firstEnableInput) {
          if (document.activeElement.tagName !== 'INPUT') {
            firstEnableInput.focus();
          }
        }

        // Trigger external loading
        if (spec.externalLoading && mode !== _mode) {
          if (_mode === 'busy') {
            spec.externalLoading.hide();
          }
          if (mode === 'busy') {
            spec.externalLoading.show();
          }
        }

        // Save current mode
        _mode = mode;
      };
      this.setErrorMsg = (/** @type {string} */ text) => {
        errorMsg.textContent = text;
      };

      return this;
    }
  };
})();

/**
 * Loading Shade
 */
const LoadingShade = (() => {
  const _shade = document.createElement('div');
  _shade.className = 'loading-shade';
  _shade.style.display = 'none';
  document.body.appendChild(_shade);

  return {
    show() {
      _shade.style.display = 'block';
    },
    hide() {
      _shade.style.display = 'none';
    }
  };
})();

const app = {
  init(language, api, loadingShade) {
    this.preventGotoPrevPage();
    this.deleteSensitiveData();

    this.api = api;
    this.language = language;
    this.keepAliveIntervalKey = null;
    this.loginForm = this.createLoginForm(
      language,
      this.onLoginFormSubmit.bind(this),
      loadingShade
    );
    this.userInfoForm = this.createUserInfoForm(
      language,
      this.onUserInfoFormSubmit.bind(this),
      loadingShade
    );

    this.loginForm.setMode('idle');
  },
  startKeepAlive() {
    clearInterval(this.keepAliveIntervalKey);
    this.keepAliveIntervalKey = setInterval(() => this.api.keepAlive(), 60000);
  },
  stopKeepAlive() {
    clearInterval(this.keepAliveIntervalKey);
  },
  async onLoginFormSubmit() {
    const { loginForm, userInfoForm, api } = this;
    const username = loginForm.form.querySelector('#login-account').value;
    const password = loginForm.form.querySelector('#login-password').value;

    loginForm.setMode('busy');
    try {
      const {
        output: { csrf_token, is_default_admin_setting }
      } = await api.login(username, password);

      if (is_default_admin_setting) {
        this.startKeepAlive();
        loginForm.setMode('hide');
        userInfoForm.setMode('idle');
      } else {
        this.toLivePage(username, password, csrf_token);
      }
    } catch {
      loginForm.setMode('error');
    }
  },
  async onUserInfoFormSubmit() {
    const { userInfoForm, api, language } = this;
    const username = userInfoForm.form.querySelector('#userinfo-account').value;
    const password = userInfoForm.form.querySelector('#userinfo-password').value;
    const confirmPassword = userInfoForm.form.querySelector('#userinfo-confirm-password').value;
    const oldPassword = api.password;

    const invalidInputErrorString = this.validateEditPasswordData(
      password,
      confirmPassword,
      oldPassword
    );
    if (invalidInputErrorString) {
      userInfoForm.setErrorMsg(language.trans(invalidInputErrorString));
      userInfoForm.setMode('error');
      return;
    }

    userInfoForm.setMode('busy');
    try {
      await api.editPassword(password);
    } catch {
      alert(`Change password failed!`);
      userInfoForm.setMode('idle');
      return;
    }
    try {
      const {
        output: { csrf_token }
      } = await api.login(username, password);

      this.toLivePage(username, password, csrf_token);
    } catch {
      alert(`Internal Error, please try to login again`);
      location.reload();
    }
  },
  toLivePage(username, password, csrf_token) {
    // save login info
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('password', password);
    sessionStorage.setItem('encodeAccount', this.api.encodedAccount(username, password));
    sessionStorage.setItem('csrf_token', csrf_token);
    localStorage.setItem('is_cloud', JSON.stringify(false));

    // stop keep alive
    this.stopKeepAlive();

    // load page
    const { port } = window.location;
    const target_url =
      location.protocol + '//' + window.location.hostname + (port ? ':' + port : '');
    document.location.replace(target_url);
  },
  validateEditPasswordData(newPassword, confirmPassword, oldPassword) {
    if (!/^[A-Za-z0-9!#$%&'\-\.@^_~]{8,16}$/.test(newPassword)) {
      return "Password length is 8-16 characters(Available characters: A-Z, a-z, 0-9, !#$%&'-.@^_~)";
    }

    if (newPassword !== confirmPassword) {
      return "These passwords don't match. Please try again.";
    }

    // if (newPassword === oldPassword) {
    //   return 'Setup account/password failed!';
    // }

    return null;
  },
  deleteSensitiveData() {
    ['username', 'password', 'encodeAccount'].forEach(key => {
      if (localStorage.getItem(key) !== null) {
        localStorage.removeItem(key);
      }
    });
    sessionStorage.clear();
  },
  preventGotoPrevPage() {
    window.location.hash = 'login';
    window.location.hash = '_login'; //again because google chrome don't insert first hash into history
    window.onhashchange = function () {
      window.location.hash = 'login';
    };
  },
  createLoginForm(language, onSubmit, loadingShade) {
    const loginForm = Object.create(DialogForm).init({
      container: document.body,
      titleText: language.trans('Login'),
      inputs: [
        {
          labelText: language.trans('Account'),
          type: 'text',
          id: 'login-account',
          required: true,
          autocomplete: 'name'
        },
        {
          labelText: language.trans('Password'),
          type: 'password',
          id: 'login-password',
          autocomplete: 'new-password'
        }
      ],
      errorText: language.trans('Account/Password Error!'),
      submitBtnText: language.trans('Confirm'),
      cancelBtnText: language.trans('Cancel'),
      onSubmit,
      externalLoading: loadingShade
    });
    return loginForm;
  },
  createUserInfoForm(language, onSubmit, loadingShade) {
    const userInfoForm = Object.create(DialogForm).init({
      container: document.body,
      titleText: language.trans('Password Setting'),
      inputs: [
        {
          labelText: language.trans('Username'),
          type: 'text',
          id: 'userinfo-account',
          required: true,
          value: 'Admin',
          disabled: true
        },
        {
          labelText: language.trans('Password'),
          type: 'password',
          id: 'userinfo-password',
          required: true,
          autocomplete: 'new-password'
        },
        {
          labelText: language.trans('Confirm Password'),
          type: 'password',
          id: 'userinfo-confirm-password',
          required: true,
          autocomplete: 'new-password'
        }
      ],
      errorText: language.trans(
        "Password length is 8-16 characters(Available characters: A-Z, a-z, 0-9, !#$%&'-.@^_~)"
      ),
      submitBtnText: language.trans('OK'),
      cancelBtnText: language.trans('Cancel'),
      onSubmit,
      externalLoading: loadingShade
    });
    return userInfoForm;
  }
};

app.init(Language, Api, LoadingShade);
